import {
  createPlanAlertStorage,
  defaultStorageAdapter,
  type StorageAdapter,
} from './createPlanAlertStorage';

export type ExpirationAlertType = 'D-7' | 'D-3' | 'D-day';

export type ExpirationAlertsState = Partial<
  Record<ExpirationAlertType, boolean>
>;

/**
 * 플랜 만료 알림 스토리지 팩토리 함수
 */
export function createPlanExpirationAlertStorage(
  storage: StorageAdapter = defaultStorageAdapter,
) {
  const alertStorage = createPlanAlertStorage<ExpirationAlertsState>(
    'plan-expiration-alerts',
    storage,
  );

  return {
    /**
     * 특정 알림이 이미 표시되었는지 확인합니다.
     */
    hasShown(alertType: ExpirationAlertType): boolean {
      return alertStorage.getState()[alertType] === true;
    },

    /**
     * 알림을 표시했다고 표시합니다.
     */
    markAsShown(alertType: ExpirationAlertType): void {
      const state = alertStorage.getState();
      state[alertType] = true;
      alertStorage.setState(state);
    },

    /**
     * 특정 알림 타입을 무효화합니다.
     */
    resetAlert(alertType: ExpirationAlertType): void {
      const state = alertStorage.getState();
      delete state[alertType];
      alertStorage.setState(state);
    },

    /**
     * 스토리지 초기화
     */
    reset(): void {
      alertStorage.reset();
    },
  };
}

/** 싱글톤 인스턴스 */
export const planExpirationAlertStorage = createPlanExpirationAlertStorage();
